import Http from "../services/Providers/Http";

const ENDPOINTS = {
  GET_USERS: "/api/staff/users",
};

export default {
  getUsers: (payload, params) => {
    return Http.get(ENDPOINTS.GET_USERS, params, null, payload);
  },
}; 